var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "wow container-iframe",
    staticStyle: {
      "position": "relative"
    }
  }, [_vm.isMP4Video ? _c('video', {
    staticClass: "video-frame",
    attrs: {
      "controls": "",
      "id": _vm.videoId,
      "poster": _vm.videoThumbnail
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.videoSource,
      "type": "video/mp4"
    }
  })]) : _c('iframe', {
    staticClass: "video-frame",
    attrs: {
      "src": _vm.videoSource,
      "id": _vm.videoId,
      "frameborder": "0",
      "loading": "lazy",
      "allowfullscreen": "true",
      "allow": "accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }